<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500px" persistent scrollable max-width="500px">
      <template #activator="{ on }">
        <app-button outlined color="mediumTwo" v-on="on">
          <app-icon color="#4d4d4d" class="mr-2">filter_list</app-icon>
          <span class="dark-text-color mr-1">Filter</span>
        </app-button>
      </template>
      <v-card flat>
        <v-card-title>
          <h6 class="title ml-2 pt-2">{{ title }}</h6>
        </v-card-title>
        <v-card-text class="filter-dialog scrolling-modal-center pl-4 pr-4 pb-4 pt-0">
          <slot />
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer />
          <app-button-cancel @click="cancel()" />
          <app-button @click="applyFilter()">Apply Filter</app-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    cancel() {
      this.$emit('filterCanceled')
      this.dialog = false
    },
    applyFilter() {
      this.$emit('filterApplied')
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dark-text-color {
  color: #4d4d4d;
}
</style>
